import user from './user';
import cert from './cert';
import contract from './contract';
import salary from './salary';
import banks from './banks';
import task from './task';
import common from './common';

export default {
    user,
    cert,
    contract,
    salary,
    banks,
    task,
    common
};
